import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import { Switch, Route } from 'react-router-dom';
import BackButton from '../../common/components/BackButton';
import { fetchTerm, createTerm, updateTerm } from './actions';
import TermSettingsForm from './SettingsForm';
import TermHolidayList from '../termHolidayPeriods/index';
import TermHolidayDetails from '../termHolidayPeriods/Details';
import { withTranslation } from 'react-i18next';
import { Panel } from 'react-bootstrap';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleTermSettingsSubmit = this.handleTermSettingsSubmit.bind(this);
		this.handleTabSelect = this.handleTabSelect.bind(this);
	}

	componentDidMount() {
		const { match, fetchTerm } = this.props;
		const termId = match.params.id;

		if (termId) {
			fetchTerm(termId);
		}
	}

	handleTermSettingsSubmit(values) {
		const { term, createTerm, updateTerm, history } = this.props;

		if (term) {
			updateTerm(term.id, values);
		} else {
			createTerm(values, history);
		}
	}

	handleTabSelect(key) {
		const { term } = this.props;
		if (term) {
			this.props.history.replace(`/terms/${term.id}/${key}`);
		}
	}

	render() {
		const { match, term, isReadonly, termTypes, schoolYears, allowOverlappingTerms, isRestrictedUser, t } = this.props;

		const selectedTab = match.params.tab || 'details';
		return (<div>
			<BackButton style={{ marginBottom: '10px' }}>{t('Common_BackToList')}</BackButton>
			<Tabs defaultActiveKey={selectedTab} onSelect={this.handleTabSelect}>
				<Tab eventKey='details' title={t('Common_Details')}>
					<Panel>
						<Panel.Heading>{t('Common_Details')}</Panel.Heading>
						<Panel.Body>
							<TermSettingsForm form={match.params.id ? 'term' : 'newTerm'} isReadonly={isReadonly} onSubmit={this.handleTermSettingsSubmit}
								initialValues={term} termTypes={termTypes} schoolYears={schoolYears} allowOverlappingTerms={allowOverlappingTerms} isRestrictedUser={isRestrictedUser} />
						</Panel.Body>
					</Panel>
				</Tab>
				{term && <Tab eventKey='termHolidayPeriods' title={t('Term_Tab_Holidays')}>
					<Switch>
						<Route path={`/terms/${term.id}/termHolidayPeriods`} exact render={props => <TermHolidayList termId={term.id} />} />
						<Route path={`/terms/${term.id}/termHolidayPeriods/new`} render={props => <TermHolidayDetails termId={term.id} {...props} />} />
						<Route path={`/terms/${term.id}/termHolidayPeriods/:id/:tab?`} render={props => <TermHolidayDetails termId={term.id} {...props} />} />
					</Switch>
				</Tab>}
			</Tabs>
		</div>);
	}
}

const mapStateToProps = (state, ownProps) => {
	const termId = ownProps.match.params.id;

	const {
		entities: { terms },
		lookups: { termTypes, schoolYears },
		configuration: { franchisor },
		auth: { currentUser }
	} = state;

	const term = terms[termId];
	return {
		term,
		isReadonly: term && term.isReadonly,
		termTypes,
		schoolYears,
		allowOverlappingTerms: franchisor && franchisor.allowOverlappingTerms,
		isRestrictedUser: currentUser.isCenterRestricted || currentUser.isFranchiseeRestricted
	};
};

export default connect(mapStateToProps, {
	fetchTerm,
	createTerm,
	updateTerm
})(withTranslation()(Details));